import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Heading2 } from '@origin-digital/style-guide';
import { Fade } from 'react-reveal';

interface TitleProps {
  title: string;
}

const TitlePropsType: React.ValidationMap<TitleProps> = {
  title: PropTypes.string
};

const Title: React.SFC<TitleProps> = ({ title }) => (
  <Fade ssrFadeout duration={800} delay={450} ssrReveal>
    <Heading2 text={title} align="center" marginBottom />
  </Fade>
);

Title.propTypes = TitlePropsType;

export default Title;
